<template>
  <div class="signup app-content bg-gray">

    <div class="notification-bar" v-if="is_announce">
      <router-link :to="'./accept_certificate'">{{$t("message.regist_result_get_money")}}</router-link>
    </div>
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./news'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.exam_list")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div v-if="exam_lists.length != 0" class="col-12 py-2">
            <p v-show="false" class="article_title mb-12"><b>{{$t("message.exam_calender")}}</b></p>
            <FullCalendar
              v-show="false"
              :options="calendarOptions"
              :events="calendarEvents"
            />
            <div class="row">
              <div class="col-5 col-md-8 py-2">
                <p class="article_title mb-12"><b>{{$t("message.exam_list")}}</b></p>
              </div>
              <div class="col-7 col-md-4">
                <p style="display:inline;">都道府県 :</p>
                <div class="active occupationWrap ml-2" style="width: 50%">
                  <b-form-select v-model="region" @change="changeRegion" :options="options" class="selectNav  text-dark" ></b-form-select>
                </div>
              </div>
            </div>

            <div v-for="exam in exam_lists" :key="exam.id">
              <b-card no-body class="overflow-hidden mb-4">
                <b-row no-gutters>
                  <b-col md="2" class="bg-navy text-center">
                    <div class="mt-5 mb-5">
                      <p class="mb-0">{{$t("message.no")}}<span>{{ exam.id }}</span>{{$t("message.times")}}</p>
                      <small v-if="is_available(exam)" class="pt-1">{{ formate_date(exam.application_start_date) }} {{$t("message.application_start")}}</small>
                    </div>
                  </b-col>
                  <b-col md="8" class="exam">
                    <b-card-body class="pt-2 pb-2">
                      <h5 v-if="invalid_d(exam.date)">
                        {{ format_y(exam.date) }}.
                        <span class="m">{{ format_m(exam.date) }}</span>.<span class="d">{{ format_d(exam.date) }}</span>
                        <span class="c">{{ exam.country }} {{$t("message.enforcement")}} </span>
                        <span class="badge badge-success" v-show="results[exam.id] != null">{{$t("message.applicated")}}</span>
                      </h5>
                      <h5 v-else>
                        {{ exam.date }}
                        <span class="c"> {{ exam.country }} {{$t("message.enforcement")}} </span>
                        <span class="badge badge-success" v-show="results[exam.id] != null">{{$t("message.applicated")}}</span>
                      </h5>
                      <b-card-text v-if="invalid_d(exam.date)">
                        {{$t("message.industry")}}: {{ INDUSTRY_DICTIONARY[exam.industry_id] }} <br>
                        {{$t("message.midle_category")}}: {{ exam.midle_category }} <br>
                        {{$t("message.reception_time")}}: {{ format_time(exam.reception_start_time) }} ~ {{ format_time(exam.reception_end_time) }}({{ format_tz() }}) <br>
                        {{$t("message.announthment_d")}}: {{ format_daytime(exam.announce_date) }}({{ format_tz() }}) <br>
                        {{$t("message.exam_region")}}: {{ exam.region }} <br>
                      </b-card-text>
                      <b-card-text v-else>
                        {{$t("message.industry")}}: {{ INDUSTRY_DICTIONARY[exam.industry_id] }} <br>
                        {{$t("message.midle_category")}}: {{ exam.midle_category }} <br>
                        <div v-if="invalid_d(exam.reception_start_time) && invalid_d(exam.reception_end_time)">
                          {{$t("message.reception_time")}}: {{ (exam.reception_start_time) }} ~ {{ (exam.reception_end_time) }} <br>
                        </div>
                        <div v-else>
                          {{$t("message.reception_time")}}: -- <br>
                        </div>
                        {{$t("message.announthment_d")}}: {{ (exam.announce_date) }} <br>
                        {{$t("message.exam_region")}}: {{ exam.region }} <br>
                      </b-card-text>
                    </b-card-body>
                      <b-card-text class="exam-footer" v-if="invalid_d(exam.date)">
                        <div v-if="invalid_d(exam.application_start_date) && invalid_d(exam.application_end_date)">
                          <b>{{$t("message.reception_period")}}</b>: {{ format_daytime(exam.application_start_date) }}({{format_tz()}}) ~ {{ format_daytime(exam.application_end_date) }}({{format_tz()}}) <br>
                        </div>
                        <div v-else>
                          <b>{{$t("message.reception_period")}}</b>: --
                        </div>
                      </b-card-text>
                      <b-card-text class="exam-footer" v-else>
                        <b>{{$t("message.reception_period")}}</b>: {{ (exam.application_start_date) }} ~ {{ (exam.application_end_date) }} <br>
                      </b-card-text>
                  </b-col>
                  <b-col md="2" class="bg-navy text-center">

                    <b-card-body class="h-100">
                        <a class="detail-link" :href="'examination/' + exam.id">{{$t("message.detail_link")}} ></a><br>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>

            <b-pagination
              v-model="currentPage"
              :total-rows="meta.total"
              :per-page="40"
              @input ="paging"
            ></b-pagination>
          </div>
          <div v-else class="col-12 order-2 order-md-1 mt-3 mb-3 text-center">
            <h2 class="article-title ">{{$t("message.no_exam_info")}}</h2>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="eventModal"  hide-footer>
      <div class="row">
        <div class="col-12 pl-4">
          <h4>{{ $t("message.move_exam_detail") }}</h4>
        </div>
      </div>

      <div class="w-100 mt-5">
        <router-link :to="'./examination/' + examId">
          <b-button  class="start py-2 px-4 width100"> {{$t("message.move")}} </b-button>
        </router-link>
      </div>
    </b-modal>

    <b-modal v-model="isFirst"  hide-footer>
      <div class="row">
        <div class="col-12 pl-4">
          <h4>{{ $t("message.pleace_select_region") }}</h4>
        </div>
        <div class="col-8 mx-auto my-4">
          <div class="active occupationWrap ml-2" style="width: 80%">
            <b-form-select v-model="region" @change="changeRegion" :options="options" class="selectNav  text-dark" ></b-form-select>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment-timezone'
import axios from 'axios';

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import jaLocale from "@fullcalendar/core/locales/ja";

export default {
  components: {
    FullCalendar
  },
  data () {
    return {
      region: '都道府県',
      occupation: undefined,
      exam_lists: [],
      results: {},
      meta: {},
      examId: '',
      idToken: localStorage.idToken,
      is_announce: false,
      eventModal: false,
      currentPage: 1,
      isFirst: true,
      calendarOptions: {
        initialView: 'dayGridMonth',
        locale: jaLocale, // 日本語化
        // カレンダーヘッダーのデザイン
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
        },
        calendarWeekends: true, // 土日を表示するか
        plugins: [dayGridPlugin,timeGridPlugin, interactionPlugin],
        eventClick: this.handleDateClick,
        events: []
      },
      options: [
        '都道府県', '北海道', '青森', '岩手', '宮城', '秋田', '山形', '福島', '茨城', '栃木', '群馬', '埼玉', '千葉', '東京', '神奈川', '新潟', "富山", '石川', '福井', '山梨', '長野',
        '岐阜', '静岡', '愛知', '三重', '滋賀', '京都', '大阪', '兵庫', '奈良', '和歌山', '鳥取', '島根', '岡山', '広島', '山口', '徳島', '香川', '愛媛', '高知', '福岡', '佐賀',
        "長崎", '熊本', '大分', '宮崎', '鹿児島', '沖縄',
      ]
    }
  },
  methods: {
    is_available(ex) {
      var d = moment(ex.application_end_date)
      if(moment().isBefore(d)) {
        return moment().isBefore(d)
      }
      return false
    },
    handleDateClick(arg) {
      this.examId = arg.event._def.publicId
      this.eventModal = true;
    },
    paging: function() {
      axios
        .get(process.env.VUE_APP_API + "/examinations?page=" + this.currentPage + "&column=id&direction=desc", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.exam_lists = response.data.examinations
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    translate: function(t) {
      axios
        .post(process.env.VUE_APP_API + "/trial_examination/translate",{text: t, lang: this.language},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
           return response.data
        }).catch(trans_error => {
          console.log('this is trans_error', trans_error)
        })
    },
    changeRegion(){
      this.isFirst = false
      axios
        .get(process.env.VUE_APP_API + "/examinations?page=" + this.currentPage + "&column=id&direction=desc&filter_columns=region&filter_values=" + this.region, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            console.log(response.data)
            this.exam_lists = response.data.examinations
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    }
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.occupation = this.memberInfo.current_industry
    if(this.occupation == undefined){
      this.occupation = undefined
    }
    await axios
      .get(process.env.VUE_APP_API + "/examinations",{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data)
        this.exam_lists = response.data.examinations
        this.results = response.data.results
        this.meta = response.data.meta

        this.exam_lists.forEach((ex, index) => {
          var d = moment(ex.announce_date)
          if(this.is_announce == false) {
            this.is_announce = d.isAfter(moment())
          }
          var m = moment(ex.date, 'YYYY-MM-DD', true)
          if(m.isValid() == false) {
            m = moment(ex.date, "YYYY年MM月DD日", true)
            if(m.isValid() == false) {
              m = moment(ex.date, "YYYY/MM/DD/", true)
              if(m.isValid() == false)
              {
                console.log(index)
                //axios
                //.post(process.env.VUE_APP_API + "/trial_examination/translate",{text: ex.date, lang: this.language},{headers: {'Authorization': 'Bearer ' + this.idToken}})
                //.then(response => {
                //  this.exam_lists[index]['date'] = response.data.text
                //  console.log('this is trans result',response.data)
                //}).catch(trans_error => {
                //  console.log('this is trans_error', trans_error)
                //})
              }
            }
          }
          this.calendarOptions.events.push({
            title: "第" + ex.id + '回',
            start: m,
            id: ex.id
          })
          if(this.language != "ja") {
            axios
              .post(process.env.VUE_APP_API + "/trial_examination/translate",{text: ex.region, lang: this.language},{headers: {'Authorization': 'Bearer ' + this.idToken}})
              .then(response => {
                ex.region = response.data.text
              }).catch(trans_error => {
                console.log('this is trans_error', trans_error)
              })
          }
          console.log(this.calendarOptions)
        })
      }).catch(error => {
        console.log('this is error', error)
      })
    this.$store.commit('setLoading', false)
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
  },
  watch:{
    memberInfo(val){
      this.occupation = val.current_industry
    },
    language(){}
  },

}
</script>

<style scoped lang="scss">
.article_title{
  font-weight: bold;
  font-size: 16px;
}

.index_orange{
  font-weight: bold;
  color: #F29147;
}

.index_red{
  font-weight: bold;
  color: #E60028;
}

.recomend-card{
  background:linear-gradient(67.94deg, #000054 0%, rgba(0, 0, 84, 0.5) 100%);
}
.solved-probrem{
  background: linear-gradient(67.94deg, #00BDE6 0%, rgba(0, 189, 230, 0.5) 100%);
}

.look_solved{
  background: linear-gradient(67.94deg, #F29147 0%, rgba(242, 145, 71, 0.5) 100%);
}

.billing{
  background: #F29147;
  color: #FFFFFF;
  font-size: 14px;
}

.mb-12{
  margin-bottom: 12px;
}
.more{
  background: #FFFFFF;
  color: #000000;
  border: #FFFFFF;
}
.bg-navy {
  background: #000054;

  p {
    color: white;
    span {
      font-size: 26px;
      font-weight: bold;
      padding: 0px 4px;
    }
  }
  small {
    color: white;
    border: 1px solid white;
    padding: 5px;
  }
}
.exam {
  border: 3px solid #bbc8e6;
  border-left: none;
  border-right: none;
  .m, .d {
    font-weight: bold;
    padding: 0px 2px;
    font-size: 32px;
  }
  .c {
    font-weight: bold;
    padding: 0px 2px;
    font-size: 28px;
  }
}
.exam-footer {
  background: #eef1f6;
  padding: 10px 30px;
}
.detail-link {
  color: white;
  top: 35%;
  position: relative;
}

.start{
  background: #F29147 !important;
  color: #FFFFFF !important;
  font-size: 16px;
  border-color: #F29147!important;
}
@media (max-width: 991.98px) {
  .mb-5, .my-5 {
    margin: 1.5rem !important;
  }
  .h-100 {
    height: auto !important;
  }
  .exam {
    .m, .d {
      font-size: 28px;
    }
    .c {
      font-size: 24px;
    }
  }

  .exam-footer {
    padding: 10px 10px;
  }
  .exam {
    border: 3px solid #bbc8e6;
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-top: none;
  }

}


</style>
